<template>
  <div style="margin:0;padding:0;width:100%;">

    <!-- Calendar -->
    <div class="calendar-card">
      <calendar-view
        :show-date="showDate"
        class="theme-modern"
        @click-date="onClickDate"
        :events="calendarItems"
      >
        <template #header="{ headerProps }">
          <div class="cv-header">
            <div class="cv-header-nav">
              <button class="previousYear"  @click="setShowDate(headerProps.previousYear)">&#x276E;&#x276E;</button>
              <button class="previousPeriod" @click="setShowDate(headerProps.previousPeriod)">&#x276E;</button>
              <button class="currentPeriod" @click="setShowDate(headerProps.currentPeriod)">Today</button>
              <button class="nextPeriod"    @click="setShowDate(headerProps.nextPeriod)">&#x276F;</button>
              <button class="nextYear"      @click="setShowDate(headerProps.nextYear)">&#x276F;&#x276F;</button>
            </div>
            <div class="periodLabel">{{ headerProps.periodLabel }}</div>
          </div>
        </template>
      </calendar-view>
    </div>

    <!-- Legend -->
    <div class="ss-legend">
      <span class="ss-legend-item"><span class="ss-legend-dot dt-work">N</span> Normal</span>
      <span class="ss-legend-item"><span class="ss-legend-dot dt-rest">R</span> Rest Day</span>
      <span class="ss-legend-item"><span class="ss-legend-dot dt-off">O</span> Off Day</span>
      <span class="ss-legend-item"><span class="ss-legend-dot dt-holiday">H</span> Holiday</span>
    </div>

    <!-- Info bar below calendar -->
    <div class="ss-info-bar">
      <span class="ss-date-label">
        {{ currentSelectedDate || 'Click a date to view details' }}
      </span>
      <span class="ss-month-link" @click="showThisMonth">
        This month: {{ currentMonth }}
      </span>
    </div>

    <!-- Table -->
    <v-data-table
      :headers="tableHeaders"
      :items="dataItems"
      dense
      class="elevation-1 mt-2"
      :items-per-page="15"
      :no-data-text="currentSelectedDate ? 'No schedule for this date' : 'Select a date or click \'This month\' to view records'"
    >
      <template v-slot:item.starttime="{ item }">{{ formatTime(item.starttime) }}</template>
      <template v-slot:item.endtime="{ item }">{{ formatTime(item.endtime) }}</template>
      <template v-slot:item.daytypecode="{ item }">
        <span :class="daytypeClass(item.daytypecode)" class="daytype-chip">{{ item.daytypecode }}</span>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import { CalendarView } from 'vue-simple-calendar';
import 'vue-simple-calendar/static/css/default.css';
import moment from 'moment';

export default {
  components: { CalendarView },

  data() {
    return {
      showDate: new Date(),
      calendarItems: [],
      mergedData: [],
      dataItems: [],
      currentSelectedDate: '',
      currentMonth: moment().format('MM-YYYY'),
      tableHeaders: [
        { text: 'Date',              value: 'shiftdate',   width: '120px', sortable: false },
        { text: 'Day Type',          value: 'daytypecode', width: '90px',  sortable: false },
        { text: 'Day Type Desc',     value: 'daytypedesc', width: '150px', sortable: false },
        { text: 'Shift Code',        value: 'shiftcode',   width: '110px', sortable: false },
        { text: 'Shift Description', value: 'shiftdesc',   sortable: false },
        { text: 'Start Time',        value: 'starttime',   width: '100px', sortable: false },
        { text: 'End Time',          value: 'endtime',     width: '100px', sortable: false },
      ],
    };
  },

  computed: {
    staffId() { return this.$store.getters.staffId; },
  },

  watch: {
    staffId(newId) {
      if (newId) {
        this.currentSelectedDate = '';
        this.loadMerged(moment(this.showDate).format('YYYY-MM'));
      }
    },
  },

  methods: {
    formatTime(val) { return val ? moment(val, 'HH:mm:ss').format('HH:mm') : '-'; },

    daytypeClass(code) {
      if (!code) return 'dt-default';
      const c = code.toUpperCase();
      if (c === 'N') return 'dt-work';
      if (c === 'R') return 'dt-rest';
      if (c === 'O') return 'dt-off';
      if (c === 'H') return 'dt-holiday';
      return 'dt-default';
    },

    daytypeEventClass(code) {
      if (!code) return 'evt-default';
      const c = code.toUpperCase();
      if (c === 'N') return 'evt-work';
      if (c === 'R') return 'evt-rest';
      if (c === 'O') return 'evt-off';
      if (c === 'H') return 'evt-holiday';
      return 'evt-default';
    },

    loadMerged(month) {
      this.$store.dispatch('post', {
        url: `/ss/attendance/schedule/merged/${this.staffId}`,
        payload: { month },
      })
        .then(res => {
          this.mergedData = res.data.rec || [];

          this.calendarItems = this.mergedData.map((r, i) => ({
            id: i + 1,
            title: '● ' + (r.daytypecode === 'N' && r.shiftcode ? r.shiftcode : (r.daytypecode || '')),
            startDate: r.shiftdate,
            classes: this.daytypeEventClass(r.daytypecode),
          }));

          if (!this.currentSelectedDate) {
            this.dataItems = this.mergedData;
          } else {
            this.dataItems = this.mergedData.filter(r => r.shiftdate === this.currentSelectedDate);
          }
        })
        .catch(err => console.error(err));
    },

    setShowDate(d) {
      this.showDate = d;
      this.currentSelectedDate = '';
      const month = moment(d).format('YYYY-MM');
      this.currentMonth = moment(d).format('MM-YYYY');
      this.loadMerged(month);
    },

    onClickDate(d) {
      const date = moment(d).format('YYYY-MM-DD');
      this.currentSelectedDate = date;
      this.dataItems = this.mergedData.filter(r => r.shiftdate === date);
    },

    showThisMonth() {
      const month = moment().format('YYYY-MM');
      this.currentSelectedDate = '';
      this.currentMonth = moment().format('MM-YYYY');
      this.showDate = new Date();
      this.loadMerged(month);
    },
  },

  mounted() {
    this.loadMerged(moment().format('YYYY-MM'));
    this.dataItems = [];
  },
};
</script>

<style scoped>
.ss-legend {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 4px 2px 4px;
  flex-wrap: wrap;
}
.ss-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.78rem;
  color: #475569;
  font-weight: 500;
}
.ss-legend-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 700;
}

.ss-info-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 4px 4px 4px;
  border-top: 1px solid #E8EDF5;
  margin-top: 4px;
}
.ss-date-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1a3a5c;
}
.ss-month-link {
  font-size: 0.83rem;
  color: #4F6BFF;
  cursor: pointer;
  font-weight: 600;
}
.ss-month-link:hover { text-decoration: underline; }

.daytype-chip {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}
.dt-work    { background: #DBEAFE; color: #1D4ED8; }
.dt-rest    { background: #DCFCE7; color: #15803D; }
.dt-off     { background: #F1F5F9; color: #475569; }
.dt-holiday { background: #FEF9C3; color: #92400E; }
.dt-default { background: #F1F5F9; color: #475569; }
</style>

<style>
/* Card wrapper */
.calendar-card {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07);
  border: 1px solid #E8EDF5;
}

/* theme-modern overrides */
.theme-modern.cv-wrapper { font-family: 'Inter', 'Segoe UI', sans-serif !important; border: none !important; }

.theme-modern .cv-header {
  background: linear-gradient(135deg, #4F6BFF 0%, #7C3AFF 100%) !important;
  border: none !important;
  padding: 14px 16px !important;
}
.theme-modern .cv-header button,
.theme-modern .cv-header .periodLabel {
  color: #ffffff !important;
  font-weight: 600 !important;
  border: none !important;
  background: rgba(255,255,255,0.15) !important;
  border-radius: 8px !important;
  padding: 4px 10px !important;
}
.theme-modern .cv-header button:hover { background: rgba(255,255,255,0.28) !important; }
.theme-modern .cv-header .periodLabel { background: transparent !important; font-size: 1.05rem !important; }

.theme-modern .cv-weekdays { background: #F8FAFF !important; border-bottom: 1px solid #E8EDF5 !important; }
.theme-modern .cv-weekday {
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  color: #64748B !important;
  text-transform: uppercase !important;
  letter-spacing: 0.06em !important;
  padding: 8px 0 !important;
  border: none !important;
}

.theme-modern .cv-weeks  { border: none !important; }
.theme-modern .cv-week   { border-bottom: 1px solid #F1F5F9 !important; min-height: 88px !important; }
.theme-modern .cv-day    {
  border-right: 1px solid #F1F5F9 !important;
  border-bottom: none !important;
  background: #fff !important;
  transition: background 0.15s !important;
}
.theme-modern .cv-day:hover { background: #F5F7FF !important; cursor: pointer; }
.theme-modern .cv-day.today { background: #EEF2FF !important; }
.theme-modern .cv-day.today .cv-day-number {
  background: #4F6BFF !important;
  color: #fff !important;
  border-radius: 50% !important;
  width: 26px !important; height: 26px !important;
  display: flex !important; align-items: center !important; justify-content: center !important;
  font-weight: 700 !important;
}
.theme-modern .cv-day-number { font-size: 0.82rem !important; color: #475569 !important; font-weight: 500 !important; padding: 6px 8px !important; }
.theme-modern .cv-day.outsideOfMonth .cv-day-number { color: #CBD5E1 !important; }

/* Calendar event — full-height cell tint + dot text below day number */
.theme-modern .cv-event {
  top: 0 !important;
  height: 100% !important;
  border: none !important;
  border-radius: 0 !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
  padding: 2.4em 4px 0 !important;
  margin: 0 !important;
  line-height: 18px !important;
  pointer-events: none;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  box-shadow: none !important;
}
.theme-modern .cv-event.evt-work    { background: transparent !important;              color: #1D4ED8 !important; }
.theme-modern .cv-event.evt-rest    { background: rgba(220, 252, 231, 0.7) !important; color: #15803D !important; }
.theme-modern .cv-event.evt-off     { background: rgba(226, 232, 240, 0.6) !important; color: #475569 !important; }
.theme-modern .cv-event.evt-holiday { background: rgba(254, 249, 195, 0.8) !important; color: #92400E !important; }
.theme-modern .cv-event.evt-default { background: transparent !important;              color: #4F6BFF !important; }
</style>
